"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textBoolean = textBoolean;
function textBoolean(value, defaultValue = false) {
    switch (value?.toLowerCase()) {
        case 'yes':
        case 'on':
            return true;
        case 'no':
        case 'off':
            return false;
        default:
            return defaultValue;
    }
}
//# sourceMappingURL=textBoolean.js.map